import React from 'react';
import { Briefcase, Clock } from 'lucide-react';

/**
 * Секция для ввода информации о трудовом стаже
 */
const WorkExperienceSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Briefcase className="w-5 h-5 mr-2 text-emerald-500" />
        Трудовой стаж
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Текущий стаж */}
        <div>
          <label htmlFor="workExperienceYears" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Текущий стаж (лет)
          </label>
          <input
            type="number"
            id="workExperienceYears"
            name="workExperienceYears"
            value={formData.workExperienceYears}
            onChange={handleInputChange}
            min="0"
            max="60"
            step="0.5"
            className={`form-input w-full ${errors.workExperienceYears ? 'input-error' : ''}`}
          />
          {errors.workExperienceYears && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.workExperienceYears}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Стаж, учтенный в СФР
          </p>
        </div>

        {/* Дополнительный неучтенный стаж */}
        <div>
          <label htmlFor="additionalExperienceYears" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Дополнительный стаж (лет)
          </label>
          <input
            type="number"
            id="additionalExperienceYears"
            name="additionalExperienceYears"
            value={formData.additionalExperienceYears}
            onChange={handleInputChange}
            min="0"
            max="30"
            step="0.5"
            className={`form-input w-full ${errors.additionalExperienceYears ? 'input-error' : ''}`}
          />
          {errors.additionalExperienceYears && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalExperienceYears}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Стаж, не учтенный в системе
          </p>
        </div>

        {/* Будущий стаж */}
        <div>
          <label htmlFor="futureWorkYears" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Планируемый стаж (лет)
          </label>
          <input
            type="number"
            id="futureWorkYears"
            name="futureWorkYears"
            value={formData.futureWorkYears}
            onChange={handleInputChange}
            min="0"
            max="50"
            step="1"
            className={`form-input w-full ${errors.futureWorkYears ? 'input-error' : ''}`}
          />
          {errors.futureWorkYears && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.futureWorkYears}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Сколько ещё планируете работать
          </p>
        </div>
      </div>

      <div className="mt-4 bg-gray-100 dark:bg-gray-700/30 p-3 rounded-lg">
        <div className="flex items-start">
          <Clock className="w-5 h-5 text-gray-600 dark:text-gray-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Требования к страховому стажу
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Для получения страховой пенсии необходим минимальный стаж 15 лет и не менее 30 пенсионных баллов. 
              Чем больше стаж, тем выше пенсия (до определенного предела).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkExperienceSection;